var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGooglePlayW = function SvgGooglePlayW(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 48,
    viewBox: "0 0 168 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 48,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 11.96C60 12.92 59.76 13.76 59.16 14.36C58.44 15.08 57.6 15.44 56.52 15.44C55.44 15.44 54.6 15.08 53.88 14.36C53.16 13.64 52.8 12.8 52.8 11.72C52.8 10.64 53.16 9.8 53.88 9.08C54.6 8.36 55.44 8 56.52 8C57 8 57.48 8.12 57.96 8.36C58.44 8.6 58.8 8.84 59.04 9.2L58.44 9.8C57.96 9.2 57.36 8.96 56.52 8.96C55.8 8.96 55.08 9.2 54.6 9.8C54 10.28 53.76 11 53.76 11.84C53.76 12.68 54 13.4 54.6 13.88C55.2 14.36 55.8 14.72 56.52 14.72C57.36 14.72 57.96 14.48 58.56 13.88C58.92 13.52 59.16 13.04 59.16 12.44H56.52V11.6H60C60 11.6 60 11.84 60 11.96Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.52 8.96012H62.28V11.2401H65.28V12.0801H62.28V14.3601H65.52V15.3201H61.32V8.12012H65.52V8.96012Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.48 15.3201H68.52V8.96012H66.48V8.12012H71.52V8.96012H69.48V15.3201Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15.3201V8.12012H75.96V15.3201H75Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0399 15.3201H79.08V8.96012H77.0399V8.12012H81.9599V8.96012H79.9199V15.3201H80.0399Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.44 14.36C90.72 15.08 89.88 15.44 88.8 15.44C87.72 15.44 86.88 15.08 86.16 14.36C85.44 13.64 85.08 12.8 85.08 11.72C85.08 10.64 85.44 9.8 86.16 9.08C86.88 8.36 87.72 8 88.8 8C89.88 8 90.72 8.36 91.44 9.08C92.16 9.8 92.52 10.64 92.52 11.72C92.52 12.8 92.16 13.64 91.44 14.36ZM86.88 13.76C87.36 14.24 88.08 14.6 88.8 14.6C89.52 14.6 90.24 14.36 90.72 13.76C91.2 13.28 91.56 12.56 91.56 11.72C91.56 10.88 91.32 10.16 90.72 9.68C90.24 9.2 89.52 8.84 88.8 8.84C88.08 8.84 87.36 9.08 86.88 9.68C86.4 10.16 86.04 10.88 86.04 11.72C86.04 12.56 86.28 13.28 86.88 13.76Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.84 15.3201V8.12012H94.92L98.4 13.7601V12.3201V8.12012H99.36V15.3201H98.4L94.68 9.44012V10.8801V15.3201H93.84Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.84 25.8802C81.96 25.8802 79.68 28.0402 79.68 31.0402C79.68 33.9202 81.96 36.2002 84.84 36.2002C87.72 36.2002 90 34.0402 90 31.0402C90 27.9202 87.72 25.8802 84.84 25.8802ZM84.84 34.0402C83.28 34.0402 81.96 32.7202 81.96 30.9202C81.96 29.1202 83.28 27.8002 84.84 27.8002C86.4 27.8002 87.72 29.0002 87.72 30.9202C87.72 32.7202 86.4 34.0402 84.84 34.0402ZM73.68 25.8802C70.8 25.8802 68.52 28.0402 68.52 31.0402C68.52 33.9202 70.8 36.2002 73.68 36.2002C76.56 36.2002 78.84 34.0402 78.84 31.0402C78.84 27.9202 76.56 25.8802 73.68 25.8802ZM73.68 34.0402C72.12 34.0402 70.8 32.7202 70.8 30.9202C70.8 29.1202 72.12 27.8002 73.68 27.8002C75.24 27.8002 76.56 29.0002 76.56 30.9202C76.56 32.7202 75.24 34.0402 73.68 34.0402ZM60.36 27.4402V29.6002H65.52C65.4 30.8002 64.92 31.7602 64.32 32.3602C63.6 33.0802 62.4 33.9202 60.36 33.9202C57.12 33.9202 54.72 31.4002 54.72 28.1602C54.72 24.9202 57.24 22.4002 60.36 22.4002C62.04 22.4002 63.36 23.1202 64.32 23.9602L65.88 22.4002C64.56 21.2002 62.88 20.2402 60.48 20.2402C56.16 20.2402 52.44 23.8402 52.44 28.1602C52.44 32.4802 56.16 36.0802 60.48 36.0802C62.88 36.0802 64.56 35.3602 66 33.8002C67.44 32.3602 67.92 30.3202 67.92 28.7602C67.92 28.2802 67.92 27.8002 67.8 27.4402H60.36ZM114.84 29.1202C114.36 27.9202 113.16 25.8802 110.52 25.8802C107.88 25.8802 105.72 27.9202 105.72 31.0402C105.72 33.9202 107.88 36.2002 110.76 36.2002C113.04 36.2002 114.48 34.7602 114.96 33.9202L113.28 32.7202C112.68 33.5602 111.96 34.1602 110.76 34.1602C109.56 34.1602 108.84 33.6802 108.24 32.6002L115.08 29.7202L114.84 29.1202ZM107.88 30.8002C107.88 28.8802 109.44 27.8002 110.52 27.8002C111.36 27.8002 112.2 28.2802 112.44 28.8802L107.88 30.8002ZM102.24 35.7202H104.52V20.7202H102.24V35.7202ZM98.64 26.9602C98.04 26.3602 97.08 25.7602 95.88 25.7602C93.36 25.7602 90.96 28.0402 90.96 30.9202C90.96 33.8002 93.24 35.9602 95.88 35.9602C97.08 35.9602 98.04 35.3602 98.52 34.7602H98.64V35.4802C98.64 37.4002 97.56 38.4802 95.88 38.4802C94.56 38.4802 93.6 37.5202 93.36 36.6802L91.44 37.5202C92.04 38.8402 93.48 40.5202 96 40.5202C98.64 40.5202 100.8 38.9602 100.8 35.2402V26.1202H98.64V26.9602ZM96 34.0402C94.44 34.0402 93.12 32.7202 93.12 30.9202C93.12 29.1202 94.44 27.8002 96 27.8002C97.56 27.8002 98.76 29.1202 98.76 30.9202C98.76 32.7202 97.56 34.0402 96 34.0402ZM125.28 20.7202H119.88V35.7202H122.16V30.0802H125.28C127.8 30.0802 130.2 28.2802 130.2 25.4002C130.2 22.5202 127.8 20.7202 125.28 20.7202ZM125.4 27.9202H122.16V22.7602H125.4C127.08 22.7602 128.04 24.2002 128.04 25.2802C127.92 26.6002 126.96 27.9202 125.4 27.9202ZM139.2 25.7602C137.52 25.7602 135.84 26.4802 135.24 28.0402L137.28 28.8802C137.76 28.0402 138.48 27.8002 139.32 27.8002C140.52 27.8002 141.6 28.5202 141.72 29.7202V29.8402C141.36 29.6002 140.4 29.2402 139.44 29.2402C137.28 29.2402 135.12 30.4402 135.12 32.6002C135.12 34.6402 136.92 35.9602 138.84 35.9602C140.4 35.9602 141.12 35.2402 141.72 34.5202H141.84V35.7202H144V29.9602C143.76 27.3202 141.72 25.7602 139.2 25.7602ZM138.96 34.0402C138.24 34.0402 137.16 33.6802 137.16 32.7202C137.16 31.5202 138.48 31.1602 139.56 31.1602C140.52 31.1602 141 31.4002 141.6 31.6402C141.36 33.0802 140.16 34.0402 138.96 34.0402ZM151.56 26.1202L149.04 32.6002H148.92L146.28 26.1202H143.88L147.84 35.2402L145.56 40.2802H147.84L153.96 26.1202H151.56ZM131.4 35.7202H133.68V20.7202H131.4V35.7202Z",
    fill: "#1B1B1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 8.7207C15.24 9.0807 15 9.6807 15 10.4007V36.9207C15 37.6407 15.24 38.2407 15.6 38.6007L15.72 38.7207L30.6 23.8407V23.7207V23.6007L15.6 8.7207Z",
    fill: "url(#paint0_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.52 28.8797L30.6 23.9597V23.7197V23.5997L35.52 18.6797L35.64 18.7997L41.52 22.1597C43.2 23.1197 43.2 24.6797 41.52 25.6397L35.52 28.8797Z",
    fill: "url(#paint1_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.64 28.7607L30.6 23.7207L15.6 38.7207C16.2 39.3207 17.04 39.3207 18.12 38.8407L35.64 28.7607Z",
    fill: "url(#paint2_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.64 18.6806L18.12 8.72064C17.04 8.12064 16.2 8.24064 15.6 8.84064L30.6 23.7206L35.64 18.6806Z",
    fill: "url(#paint3_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.52 28.6406L18.12 38.4806C17.16 39.0806 16.32 38.9606 15.72 38.4806L15.6 38.6006L15.72 38.7206C16.32 39.2006 17.16 39.3206 18.12 38.7206L35.52 28.6406Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M15.6 38.4808C15.24 38.1208 15.12 37.5208 15.12 36.8008V36.9208C15.12 37.6408 15.36 38.2408 15.72 38.6008V38.4808H15.6Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M41.52 25.2807L35.52 28.6407L35.64 28.7607L41.52 25.4007C42.36 24.9207 42.72 24.3207 42.72 23.7207C42.72 24.3207 42.24 24.8007 41.52 25.2807Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M18.12 8.84017L41.52 22.1602C42.24 22.6402 42.72 23.1202 42.72 23.7202C42.72 23.1202 42.36 22.5202 41.52 22.0402L18.12 8.72017C16.44 7.76017 15.12 8.60017 15.12 10.5202V10.6402C15.12 8.72017 16.44 7.88017 18.12 8.84017Z",
    fill: "#1B1B1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29.2796,
    y1: 10.1723,
    x2: 9.14076,
    y2: 30.3112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 43.7213,
    y1: 23.7214,
    x2: 14.685,
    y2: 23.7214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 32.9124,
    y1: 26.476,
    x2: 5.60245,
    y2: 53.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 11.8768,
    y1: -0.0679176,
    x2: 24.0719,
    y2: 12.1271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePlayW, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-play-w.4838aeb1.svg";
export { ForwardRef as ReactComponent };